<template>
  <div>
    <div
      :style="{
        padding: '24px',
        margin: '24px 16px 24px 16px',
        background: '#fff',
        minHeight: '100px',
      }"
    >
      <a-form-model
        ref="ruleForm"
        layout="inline"
        :model="formInline"
        @submit="handleSubmit"
        @submit.native.prevent
      >
        <a-row>
          <a-col :span="5">
            <a-form-model-item label="订单编号" prop="orderNo">
              <a-input v-model="formInline.orderNo" placeholder="请输入">
              </a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="5">
            <a-form-model-item label="用户id" prop="userUid">
              <a-input v-model="formInline.userUid" placeholder="请输入"> </a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="5">
            <a-form-model-item label="手机号码" prop="phone">
              <a-input v-model="formInline.phone" placeholder="请输入"> </a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="7">
            <a-form-model-item label="订单时间" prop="createTime">
              <a-range-picker v-model="formInline.createTime" format="YYYY-MM-DD HH:mm:ss" @change="onChange" />
            </a-form-model-item>
          </a-col>
          <a-col :span="4">
            <a-form-model-item>
              <a-button type="primary" @click="query">
                查询
              </a-button>
            </a-form-model-item>
            <a-form-model-item>
              <a-col :span="6">
                <a-button style="margin-left: 10px" @click="resetForm">
                  重置
                </a-button>
              </a-col>
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>
    </div>

    <a-layout-content style="margin: 0 16px">
      <div :style="{ padding: '24px', background: '#fff', minHeight: '360px' }">
        <intergralOrderContent
          ref="aaa"
          :formInline="formInline"
        ></intergralOrderContent>
      </div>
    </a-layout-content>
  </div>
</template>

<script>
import intergralOrderContent from '@/views/orderManagement/intergralOrder/intergralOrderContent.vue';
export default {
  components: {
    intergralOrderContent,
  },
  data() {
    return {
      formInline: {
        orderNo: "",
        limit: 10,
        page: 1,
        startTime: null,
        endTime: null,
        userUid:null
      },
    };
  },
  methods: {
    handleSubmit() {
      console.log('兑换表单sumbit:',this.formInline);
    },
    resetForm() {
      console.log('执行重置表单');
      this.formInline = {
        orderNo: "",
        startTime: null,
        endTime: null,
        partnerName:"",
        createTime: null,
        userUid:null,
        phone: ""
      };
      // 触发子组件重新查询,确保表格数据也重置
      this.$refs.aaa.data = [];
      this.$refs.aaa.sumIntegral = 0;
     
    },
    onChange(date, dateString) {
      console.log(date, dateString);
      this.formInline.startTime = dateString ? dateString[0] : "";
      this.formInline.endTime = dateString ? dateString[1] : "";
    },
    query() {
      // 重置页码为第一页
      this.formInline.page = 1;
      this.formInline.limit = 10;
      this.$refs.aaa.search();
    },
   
  },
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/views/orderManagement/intergralOrder/intergralOrderHome.vue